import userpfp from './../media/ctpfp.png'

export const CTProfileData = [
    {
        ctname: 'Sania Paro',
        ctusername: 'username',
        ctlocation: 'Akurdi, Pune',
        ctage: 25,
        workexperience: 5,
        services: 'Blood Test, X-Ray, MRI Scan, ECG, Ultrasound',
        ctreviews: [
            {
                name: 'Kiara',
                icon: userpfp,
                rating: 5,
                review: 'This service was awesome and really lovedit.'
            },
            {
                name: 'Reva',
                icon: userpfp,
                rating: 4,
                review: 'Great caretaker, very responsible.'
            },
            {
                name: 'Kiara',
                icon: userpfp,
                rating: 5,
                review: 'This service was awesome and really lovedit.'
            },
            {
                name: 'Reva',
                icon: userpfp,
                rating: 4,
                review: 'Great caretaker, very responsible.'
            },
            {
                name: 'Kiara',
                icon: userpfp,
                rating: 5,
                review: 'This service was awesome and really lovedit.'
            },
            {
                name: 'Reva',
                icon: userpfp,
                rating: 4,
                review: 'Great caretaker, very responsible.'
            },
        ],
    },
];

export default CTProfileData;